var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthRising({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#93b5ff;opacity:0.15;}.b{fill:none;stroke:#93b5ff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1,5.5,6.5,2V5.5L13,1m0,0V4m0-3H9.5",
    transform: "translate(5 8.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthRising);
export default __webpack_public_path__ + "static/media/growth-rising.f0f426a82b14d75fb0602d8bcc220ab8.svg";
export { ForwardRef as ReactComponent };